import { inject, Injectable, signal } from '@angular/core'
import { NavigationEnd, Router } from '@angular/router'
import { filter } from 'rxjs'
import { isUuid } from '@app/common/util/is-uuid'

@Injectable({
  providedIn: 'root',
})
export class RouterAdapterService {
  private readonly router = inject(Router)

  // Public signals
  public readonly routeOrganizationId = signal<string | undefined>(undefined)

  constructor() {
    this.routeOrganizationId.set(this.getRouteOrganizationId())
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      this.routeOrganizationId.set(this.getRouteOrganizationId())
    })
  }

  getRouteOrganizationId(): string | undefined {
    const urlSegments = this.router.url.split('/').filter(segment => segment !== '')
    if (urlSegments.length === 0) return undefined
    const [firstSegment] = urlSegments
    return isUuid(firstSegment) ? firstSegment : undefined
  }
}
